import React from 'react';
import PropTypes from 'prop-types';
import Table from './reusable/table';

const { array } = PropTypes;

interface AnalyticsChartFeedbackProps {
  feedback: Chart[],
}

interface Chart {
  name: string;
  upvotes: number;
  downvotes: number;
}

export default class AnalyticsChartFeedback extends React.Component<AnalyticsChartFeedbackProps, any> {
  static propTypes = {
    feedback: array.isRequired,
  }

  render() {
    return (
      <Table
        headers={this.getHeaders()}
        data={this.getData()}
        fancy
      />
    );
  }

  getHeaders = () => {
    return ['Chart', 'Upvotes', 'Downvotes'];
  }

  getData = () => {
    const data = this.props.feedback.map((chart) => {
      return {
        Chart: chart.name,
        Upvotes: chart.upvotes,
        Downvotes: chart.downvotes,
      };
    });

    return data;
  }
}
